// The bridge the desktop (Electron) preload injects on `window` — see `Backend/desktop/src/preload.ts`.
// Only the `isDesktop` marker is needed here for benign UI branching; the full typed API lives in the
// web app (`services/app/src/util/desktop`). We read it via a local cast rather than a `declare global`
// so this shared package doesn't collide with the app's own (fuller) `window.notabilityDesktop` type.
interface DesktopBridgeWindow {
  notabilityDesktop?: {isDesktop?: boolean}
}

/**
 * True when the page is running inside the Notability desktop (Electron) app. Guarded for SSR
 * (`window` is undefined on the server). Spoofable in the desktop shell's remote mode, so use only
 * for benign branching — hiding an upsell qualifies.
 */
export function isInDesktopApp(): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  return (window as unknown as DesktopBridgeWindow).notabilityDesktop?.isDesktop === true
}
